import { Route, Routes } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { GlobalLoadingState } from '@application/recoils/atom';
import HomePage from '@presentation/features/home';
import NotFoundPage from '@presentation/features/notFound';
import LoadingPage from '@presentation/components/loading';

function App() {
  const isGlobalLoading = useRecoilValue(GlobalLoadingState);

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />}></Route>
        <Route path="*" element={<NotFoundPage />}></Route>
      </Routes>

      {isGlobalLoading && <LoadingPage />}
    </>
  );
}

export default App;
